module.exports = __webpack_public_path__ + "img/IPQC.917997e5.jpg";